export const MAX_DASHBOARD_TABLE_ITEMS = 5;
